import GetInsightsHeader from './Header';

export default GetInsightsHeader;
